import React, { useEffect, useState, useMemo, useContext, useRef } from "react";
import CategoriesForm from "../../components/CategoriesCreationForm/CategoriesForm";
import Card from "../../components/ConfigurationCards";
import SurveyForm from "../../components/SurveyCreationForm";
import SurveyCategories from "../../components/SurveyCategories";
import QuestionCategories from "../../components/QuestionCategories";
import SurveyList from "../../components/SurveyList";
import PortalModal from "../../Portals";
import SurveyCreationMain from "../../containers/SurveyCreationMainPage/SurveyCreationMain";
import PubSub from "pubsub-js";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import InfoIcon from "@material-ui/icons/Info";
import { Form } from "react-bootstrap";
import {
  ALL_SURVEY_CATEGORIES,
  CURRENT_USER_INFO,
  USERS_GROUPS_BY_APPROVER_ID,
} from "../../GraphQL/Queries";
import { UPDATE_APPROVER } from "../../GraphQL/Mutations";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { theme as themeConfig } from "../../themes/themes";
import {
  CardsWrapper,
  GeneralStyle,
  ContentModalInfo,
  CloseModalInfo,
  TextModalInfo,
  ButtonInfo,
  TableViewButton,
  SearchField,
  ActionTooltipContainer,
  useStyles,
} from "./AdminPage.styled";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import { ContextQuestions } from "../../Store/StoreQuestions";
import ApproversComponent from "../../components/ApproversComponent/ApproversComponent";
import { NotificationManager } from "react-notifications";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import SearchIcon from "@material-ui/icons/Search";
import { Tooltip } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { ReactComponent as SurveyManagementIcon } from "../../assets/svg/survey-management-icon.svg";
import HeaderComponent from "../../components/Header/Header";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { Clear } from "@material-ui/icons";
import { AntSwitch } from "../../helpers/antSwitch";
import { AntSubTab } from "../../helpers/antSubTab";
import { ROLES } from "../../util/RolesConstants";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: "1px solid #dadde9",
    width: "auto",
  },
}))(Tooltip);

function AdminPage() {
  const [updateData, setUpdateData] = useState({});
  const [, dispatch] = useContext(ContextQuestions);
  const [selectedMenu, setSelectedMenu] = useState(["new", "New Survey"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showSurveyCreationMain, setShowSurveyCreationMain] = useState({
    idSurvey: 0,
    isGlobal: false,
    isTemplate: false,
    clientTpCodes: [],
    isIntegrated: false,
    isEditSurvey: false,
    dataEditSurvey: null,
    show: false,
    OnlyAssigned: false,
    onlyReviewWithComments: false,
  });
  const user = useMemo(() => getStateLoginComplete(), []);
  const { data } = useQuery(ALL_SURVEY_CATEGORIES);
  const [activeUnderApproval, setActiveUnderApproval] = useState(false);
  const [activeApprovalsRequested, setActiveApprovalsRequested] =
    useState(false);
  const [activeAll, setActiveAll] = useState(true);
  const [showCards, setShowCards] = useState(true);
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();

  const classes = useStyles();
  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabsSurveyState, setValueTabsSurveyState] = useState(2);

  const { data: userdata } = useQuery(CURRENT_USER_INFO, {
    variables: { userId: user.userId },
    context: { clientName: "LinkUsers" },
  });

  const [usersRegistered, setUsersRegistered] = useState([]);
  const [groupRegistered, setGroupRegistered] = useState();
  const [approverSelected, setApproverSelected] = useState(null);
  const [usersSelected, setUsersSelected] = useState([]);
  const [groupsSelected, setGroupsSelected] = useState([]);
  const [userDeleted, setUserDeleted] = useState([]);
  const [groupDeleted, setGroupDeleted] = useState([]);
  const [updateApprover] = useMutation(UPDATE_APPROVER);
  const location = useLocation();
  const [surveyEdit, setSurveyEdit] = useState(null);

  useEffect(() => {
    if (location?.state?.idSurvey) {
      setSurveyEdit(location.state.idSurvey);
    }
  }, [location?.state?.idSurvey]);

  const [addedUserId, setAddedUserId] = useState();

  const [runQueryUsersGroupsByApproverId] = useLazyQuery(
    USERS_GROUPS_BY_APPROVER_ID,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultUsersApproverId =
          data?.usersGroupsByApproverId?.outputData?.users.map((item) => {
            return {
              value: item?.userId,
              label: item?.userName,
              added: true,
            };
          });
        setUsersSelected(resultUsersApproverId);
        setAddedUserId(resultUsersApproverId?.map?.((x) => x.value));
        let resultGroupsApproverId =
          data?.usersGroupsByApproverId?.outputData?.groups.map((item) => {
            return {
              value: item?.groupId,
              name: item?.groupName,
              added: true,
            };
          });
        setGroupsSelected([]);
        setGroupsSelected(resultGroupsApproverId);
      },
    }
  );

  useEffect(() => {
    if (approverSelected) {
      runQueryUsersGroupsByApproverId({
        variables: { approverId: approverSelected },
      });
    }
  }, [approverSelected]);

  useEffect(() => {
    PubSub.subscribe("dataEditSurveyCreationMain", (e, data) => {
      setShowSurveyCreationMain({
        idSurvey: data.idSurvey,
        isGlobal: data.isGlobal ? data.isGlobal : false,
        isTemplate: data.isTemplate ? data.isTemplate : false,
        clientTpCodes: data.clientTpCodes ? data.clientTpCodes : [],
        isIntegrated: false,
        isEditSurvey: true,
        show: true,
        dataEditSurvey: data?.data,
      });
    });
    dispatch({ type: "CLEAN_QUESTIONS" });
    dispatch({ type: "CLEAN_STYLES" });
    return () => {
      PubSub.unsubscribe("dataEditSurveyCreationMain");
    };
  }, []);

  useEffect(() => {
    if (usersRegistered || groupRegistered) {
      handleUpdateApprover();
    }
  }, [usersRegistered, groupRegistered]);

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    }
    if (formTrigger === selectedMenu[0]) {
      setFormTrigger(selectedMenu[0]);
    }
  }, [formTrigger, selectedMenu]);

  let handleApprovalsRequested = () => {
    setActiveApprovalsRequested(true);
    setActiveUnderApproval(false);
    setActiveAll(false);
  };

  let handleUnderApproval = () => {
    setActiveApprovalsRequested(false);
    setActiveUnderApproval(true);
    setActiveAll(false);
  };

  let handleAll = () => {
    setActiveApprovalsRequested(false);
    setActiveUnderApproval(false);
    setActiveAll(true);
  };

  let createNew = (groupsSelected, usersSelected) => {
    setUsersRegistered(
      usersSelected
        .filter((f) => f.added !== true)
        .map((item) => {
          return item.value;
        })
    );

    setGroupRegistered(
      groupsSelected
        .filter((f) => f.added !== true)
        .map((item) => {
          return {
            groupId: 0,
            groupName: item.groupName,
            usersInGroup: [...item.userIds],
          };
        })
    );
  };

  let handleUpdateApprover = () => {
    if (approverSelected) {
      updateApprover({
        variables: {
          approverId: approverSelected,
          addUserIds: usersRegistered.filter(
            (x) => ![...addedUserId].includes(x)
          ),
          addGroups: groupRegistered,
          removeUsersIds: userDeleted,
          removeGroupsIds: groupDeleted,
        },
      })
        .then((response) => {
          NotificationManager.success("Approver updated", "", 5000);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  };

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      let context = this;
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch.apply(context, arguments);
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  let showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "new":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            code="new"
            title="Create Survey"
            subtitle="survey creation with different question style"
            footerText="Create new SURVEY now"
            setFormTrigger={setFormTrigger}
          />
        );
      case "survey":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            code="survey"
            title="Survey Category"
            subtitle="Category Administration"
            footerText="New survey category"
            setFormTrigger={setFormTrigger}
          />
        );
      case "question":
        return (
          <Card
            activeicon={true}
            icon="plus"
            iconplusactive={false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            code="question"
            title="Question Category"
            subtitle="Category Administration"
            footerText="New question category"
            setFormTrigger={setFormTrigger}
          />
        );
      default:
        break;
    }
  };

  let showApprovalFlowButton = () => {
    let hiddenSubTab =
      user.roleId === ROLES.SUPERVISOR ||
      user.roleId === ROLES.WELLNESS_PROFESSIONAL ||
      user.roleId === ROLES.AGENT;
    return (
      <div style={{ margin: "0 auto" }}>
        <AntTabs aria-label="Manage Survey" value={valueTabsSurveyState}>
          <AntSubTab
            label="Approvals Requested"
            id="approvalsRequested"
            hidden={hiddenSubTab}
            onClick={() => {
              resetSearchString();
              setValueTabsSurveyState(0);
              handleApprovalsRequested();
            }}
          />
          <AntSubTab
            label="Under Approval"
            id="underApproval"
            hidden={hiddenSubTab}
            onClick={() => {
              resetSearchString();
              setValueTabsSurveyState(1);
              handleUnderApproval();
            }}
          />
          <AntSubTab
            label="All"
            id="all"
            onClick={() => {
              resetSearchString();
              setValueTabsSurveyState(2);
              handleAll();
            }}
          />
        </AntTabs>
      </div>
    );
  };

  let showSelectedMenuTable = () => {
    switch (selectedMenu[0]) {
      case "new":
        return (
          <SurveyList
            setShowSurveyCreationMain={setShowSurveyCreationMain}
            formTrigger={formTrigger}
            showCards={showCards}
            setShowCards={setShowCards}
            activeApprovalsRequested={activeApprovalsRequested}
            activeUnderApproval={activeUnderApproval}
            activeAll={activeAll}
            searchBy={searchTxt}
            surveyEdit={surveyEdit}
            sortingColumns={true}
            itsSurvey={true}
          />
        );
      case "survey":
        return (
          <SurveyCategories
            formTrigger={formTrigger}
            setFormTrigger={setFormTrigger}
            setupdateData={setUpdateData}
            showCards={showCards}
            searchBy={searchTxt}
            setShowCards={setShowCards}
          />
        );
      case "question":
        return (
          <QuestionCategories
            formTrigger={formTrigger}
            setFormTrigger={setFormTrigger}
            setupdateData={setUpdateData}
            showCards={showCards}
            searchBy={searchTxt}
            setShowCards={setShowCards}
          />
        );
      case "approver":
        return (
          <ApproversComponent
            titleApproval={"Approvers"}
            formTrigger={formTrigger}
            usersSelected={usersSelected}
            setUsersSelected={setUsersSelected}
            groupsSelected={groupsSelected}
            setGroupsSelected={setGroupsSelected}
            createNew={createNew}
            approverSelected={approverSelected}
            setApproverSelected={setApproverSelected}
            userDeleted={userDeleted}
            setUserDeleted={setUserDeleted}
            groupDeleted={groupDeleted}
            setGroupDeleted={setGroupDeleted}
          />
        );
      default:
        break;
    }
  };

  let showCategoryForm = () => {
    switch (formTrigger) {
      case "new":
        return (
          <PortalModal>
            {data?.allCategoriesSurvey.outputData.length ? (
              <SurveyForm
                user={user}
                setShowSurveyCreationMain={setShowSurveyCreationMain}
                setFormTrigger={setFormTrigger}
                userdata={userdata}
                setShowLoader={setShowLoader}
              />
            ) : (
              <ContentModalInfo>
                <CloseModalInfo>
                  <span
                    onClick={() => setFormTrigger("")}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        setFormTrigger("");
                      }
                    }}
                  >
                    X
                  </span>
                </CloseModalInfo>
                <TextModalInfo>
                  <InfoIcon />
                  <p>
                    There are no question survey categories created. Please
                    create at least one to proceed to create survey.
                  </p>
                </TextModalInfo>
                <div
                  style={{
                    display: "inline-flex",
                    margin: "auto",
                    width: "100%",
                  }}
                >
                  <ButtonInfo onClick={() => setFormTrigger("")}>Ok</ButtonInfo>
                </div>
              </ContentModalInfo>
            )}
          </PortalModal>
        );
      case "survey":
        return (
          <PortalModal>
            <CategoriesForm
              setupdateData={setUpdateData}
              updateData={updateData}
              formTrigger={formTrigger}
              title={
                updateData.idCategorySurvey
                  ? "Update survey category"
                  : "New survey category"
              }
              setFormTrigger={setFormTrigger}
            />
          </PortalModal>
        );
      case "question":
        return (
          <PortalModal>
            <CategoriesForm
              setupdateData={setUpdateData}
              updateData={updateData}
              formTrigger={formTrigger}
              title={
                updateData.idCategoryQuestion
                  ? "Update question category"
                  : "New question category"
              }
              setFormTrigger={setFormTrigger}
            />
          </PortalModal>
        );
      default:
        break;
    }
  };

  const resetSearchString = () => {
    setSearchTxt("");
    if (rSearch?.current) rSearch.current.value = "";
  };

  return (
    <>
      {!showSurveyCreationMain.show && (
        <GeneralStyle>
          <HeaderComponent
            Icon={SurveyManagementIcon}
            text={"Surveys Management"}
          ></HeaderComponent>
          {user && user.roleId !== ROLES.AGENT ? (
            <h1>{/* selectedMenu[1] */}</h1>
          ) : (
            <h1>Available Surveys</h1>
          )}
          {user && user.roleId !== ROLES.AGENT && (
            <div className={classes.root}>
              <Paper position="static" style={{ borderRadius: "0px" }}>
                <AntTabs aria-label="Manage Survey" value={valueTabs}>
                  <AntTab
                    label="Surveys"
                    id="new"
                    onClick={() => {
                      setSelectedMenu(["new", "New Survey"]);
                      setValueTabs(0);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                  <AntTab
                    label="Survey Category"
                    id="survey"
                    onClick={() => {
                      setSelectedMenu(["survey", "Survey Categories"]);
                      setValueTabs(1);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                  <AntTab
                    label="Question Category"
                    id="question"
                    onClick={() => {
                      setSelectedMenu(["question", "Question Categories"]);
                      setValueTabs(2);
                      setShowCards(true);
                      resetSearchString();
                    }}
                  />
                  <AntTab
                    label="Approvers"
                    id="approver"
                    hidden={
                      user.roleId === ROLES.COUNTRY_ADMIN ||
                        user.roleId === ROLES.SUPERVISOR ||
                        user.roleId === ROLES.AGENT
                        ? true
                        : false
                    }
                    onClick={() => {
                      setSelectedMenu(["approver", "Approvers"]);
                      setValueTabs(3);
                      setUsersSelected([]);
                      setGroupsSelected([]);
                      setApproverSelected();
                      resetSearchString();
                    }}
                  />
                </AntTabs>
              </Paper>
              <CardsWrapper className="pt-3 pb-2" valueTabs={valueTabs}>
                {showSelectedMenu()}
                {valueTabs === 0 && showApprovalFlowButton()}
                {valueTabs !== 3 && (
                  <div className="right-section">
                    <SearchField>
                      <SearchIcon style={{ color: themeConfig.text.primary }} />
                      <Form.Control
                        type="text"
                        placeholder="Search"
                        onChange={handleSearch}
                        ref={rSearch}
                      />
                      <Clear
                        style={{
                          right: "0",
                          color: themeConfig.neutral.gray[2600],
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          rSearch.current.value = "";
                          setSearchTxt("");
                        }}
                      />
                    </SearchField>
                    <div className="table-action">
                      <Tooltip title="View List">
                        <TableViewButton
                          iconColor={showCards}
                          onClick={() => setShowCards(false)}
                          className="MuiButtonBase-root MuiIconButton-root"
                        >
                          <span
                            style={{ width: "fit-content" }}
                            className="MuiIconButton-label"
                          >
                            <ViewList className="list-view" />
                          </span>
                        </TableViewButton>
                      </Tooltip>
                      <Tooltip title="View Cards">
                        <TableViewButton
                          iconColor={showCards}
                          onClick={() => setShowCards(true)}
                          style={{ borderLeft: "none" }}
                          className="MuiButtonBase-root MuiIconButton-root"
                        >
                          <span
                            style={{ width: "fit-content" }}
                            className="MuiIconButton-label"
                          >
                            <ViewCards className="card-view" />
                          </span>
                        </TableViewButton>
                      </Tooltip>
                    </div>
                  </div>
                )}
              </CardsWrapper>
              <div
                style={{
                  width: "100%",
                  textAlign: "right",
                  paddingRight: "1.5rem",
                }}
              >
                {showCards && valueTabs === 0 && (
                  <HtmlTooltip
                    arrow
                    placement="top"
                    title={
                      <ActionTooltipContainer>
                        <Button className="tooltip-btn disabled-btn">
                          Activate
                        </Button>
                        <label>Inactive survey</label>
                        <Button className="tooltip-btn">Activate</Button>
                        <label>Ready to activate</label>
                        <AntSwitch size="small" checked={false} />
                        <label style={{ marginBottom: "0.5rem" }}>
                          Disable survey
                        </label>
                        <AntSwitch size="small" checked={true} />
                        <label>Enable survey</label>
                      </ActionTooltipContainer>
                    }
                  >
                    <div style={{ display: "inline", width: "auto" }}>
                      <InfoIcon />
                      <label>Actions</label>
                    </div>
                  </HtmlTooltip>
                )}
              </div>
            </div>
          )}
          {showSelectedMenuTable()}
          {showCategoryForm()}
        </GeneralStyle>
      )}
      {showSurveyCreationMain.show && (
        <SurveyCreationMain
          idSurvey={showSurveyCreationMain.idSurvey}
          isIntegrated={showSurveyCreationMain.isIntegrated}
          isEditSurvey={showSurveyCreationMain.isEditSurvey}
          dataEditSurvey={showSurveyCreationMain.dataEditSurvey}
          OnlyAssigned={showSurveyCreationMain.OnlyAssigned}
          onlyReviewWithComments={showSurveyCreationMain.onlyReviewWithComments}
          ShowSurveyCreationMain={showSurveyCreationMain}
          setShowSurveyCreationMain={setShowSurveyCreationMain}
        />
      )}
      {showLoader && <ModalLoader />}
    </>
  );
}

export default AdminPage;
